package prescription.components

import antd.button.button
import antd.form.form
import antd.form.formItem
import antd.input.input
import antd.input.textArea
import antd.message.message
import antd.pageheader.pageHeader
import com.jingfangpai.common.orm.mapping.Prescription
import external.toJsObject
import kotlinext.js.Object
import kotlinx.browser.window
import react.*
import react.dom.div
import react.dom.jsStyle
import prescription.containers.PrescriptionEditPageContext
import react.router.dom.useHistory
import setTitle
import LearningRoute

external interface PrescriptionEditProps : RProps {
    var id: String
}

val PrescriptionEdit = functionalComponent<PrescriptionEditProps> { props ->

    val ctx = useContext(PrescriptionEditPageContext)
    val history = useHistory()
    val (prescription, setPrescription) = useState(Prescription())
    val (loading, setLoading) = useState(false)
    val (saving, setSaving) = useState(false)

    useEffect(props.id) {
        if (props.id != "new" && props.id.isNotBlank()) {
            setLoading(true)
            ctx.getDetail(props.id, { resp ->
                setLoading(false)
                if (resp.ok() && resp.data != null) {
                    setPrescription(resp.data!!)
                    setTitle("编辑方剂 - ${resp.data!!.name ?: ""}")
                } else {
                    message.error("获取方剂失败")
                }
            }, {
                setLoading(false)
                message.error("获取方剂失败")
            })
        } else {
            setTitle("新增方剂")
        }
    }

    fun updatePrescription(updater: (Prescription) -> Unit) {
        val newPrescription = Object.assign(Prescription(), prescription)
        updater(newPrescription)
        setPrescription(newPrescription)
    }

    fun save() {
        setSaving(true)
        ctx.save(prescription, { resp ->
            setSaving(false)
            if (resp.ok()) {
                message.success("保存成功")
                history.push(LearningRoute.PrescriptionDetail.link.url.replace(":id", resp.data?.id ?: ""))
            } else {
                message.error("保存失败：${resp.message}")
            }
        }, {
            setSaving(false)
            message.error("保存失败")
        })
    }

    div("PrescriptionEdit") {
        attrs.jsStyle = kotlinext.js.js {
            margin = "0 auto"
            maxWidth = "800px"
        }

        pageHeader {
            attrs {
                className = "prescription-edit-page-header-responsive"
                onBack = {
                    window.history.back()
                }
                title = if (props.id == "new") "新增方剂" else "编辑方剂"
                subTitle = ""
            }
        }

        if (loading) {
            div {
                +"加载中..."
            }
        } else {
            form {
                attrs {
                    layout = "vertical"
                }

                formItem {
                    attrs {
                        label = "名称"
                    }
                    input {
                        attrs {
                            value = prescription.name ?: ""
                            placeholder = "请输入方剂名称"
                            disabled = saving
                            onChange = { event: dynamic ->
                                // Note: This needs proper enum handling based on PrescriptionName definition
                                updatePrescription { it.name = event.target.value as String }
                            }
                        }
                    }
                }

                formItem {
                    attrs {
                        label = "出处"
                    }
                    input {
                        attrs {
                            value = prescription.source ?: ""
                            placeholder = "请输入出处"
                            disabled = saving
                            onChange = { event: dynamic ->
                                updatePrescription { it.source = event.target.value as String }
                            }
                        }
                    }
                }

                formItem {
                    attrs {
                        label = "组成"
                    }
                    textArea {
                        attrs {
                            value = prescription.composition ?: ""
                            rows = 4
                            placeholder = "请输入组成"
                            disabled = saving
                            onChange = { event: dynamic ->
                                updatePrescription { it.composition = event.target.value as String }
                            }
                        }
                    }
                }

                formItem {
                    attrs {
                        label = "用法"
                    }
                    textArea {
                        attrs {
                            value = prescription.administration ?: ""
                            rows = 4
                            placeholder = "请输入用法"
                            disabled = saving
                            onChange = { event: dynamic ->
                                updatePrescription { it.administration = event.target.value as String }
                            }
                        }
                    }
                }

                formItem {
                    attrs {
                        label = "功效"
                    }
                    textArea {
                        attrs {
                            value = prescription.actions ?: ""
                            rows = 4
                            placeholder = "请输入功效"
                            disabled = saving
                            onChange = { event: dynamic ->
                                updatePrescription { it.actions = event.target.value as String }
                            }
                        }
                    }
                }

                formItem {
                    attrs {
                        label = "主治"
                    }
                    textArea {
                        attrs {
                            value = prescription.indications ?: ""
                            rows = 4
                            placeholder = "请输入主治"
                            disabled = saving
                            onChange = { event: dynamic ->
                                updatePrescription { it.indications = event.target.value as String }
                            }
                        }
                    }
                }

                formItem {
                    attrs {
                        label = "禁忌"
                    }
                    textArea {
                        attrs {
                            value = prescription.contraindication ?: ""
                            rows = 4
                            placeholder = "请输入禁忌"
                            disabled = saving
                            onChange = { event: dynamic ->
                                updatePrescription { it.contraindication = event.target.value as String }
                            }
                        }
                    }
                }

                formItem {
                    attrs {
                        label = "方解"
                    }
                    textArea {
                        attrs {
                            value = prescription.formulaAnalysis ?: ""
                            rows = 6
                            placeholder = "请输入方解"
                            disabled = saving
                            onChange = { event: dynamic ->
                                updatePrescription { it.formulaAnalysis = event.target.value as String }
                            }
                        }
                    }
                }

                formItem {
                    attrs {
                        label = "应用"
                    }
                    textArea {
                        attrs {
                            value = prescription.applications ?: ""
                            rows = 6
                            placeholder = "请输入应用"
                            disabled = saving
                            onChange = { event: dynamic ->
                                updatePrescription { it.applications = event.target.value as String }
                            }
                        }
                    }
                }

                formItem {
                    attrs {
                        label = "常见体征症状"
                    }
                    textArea {
                        attrs {
                            value = prescription.keySignSymptoms ?: ""
                            rows = 6
                            placeholder = "请输入常见体征症状"
                            disabled = saving
                            onChange = { event: dynamic ->
                                updatePrescription { it.keySignSymptoms = event.target.value as String }
                            }
                        }
                    }
                }

                formItem {
                    attrs {
                        label = "相近功效方剂比较鉴别"
                    }
                    textArea {
                        attrs {
                            value = prescription.differentiation ?: ""
                            rows = 6
                            placeholder = "请输入比较鉴别"
                            disabled = saving
                            onChange = { event: dynamic ->
                                updatePrescription { it.differentiation = event.target.value as String }
                            }
                        }
                    }
                }

                formItem {
                    button {
                        attrs {
                            type = "primary"
                            onClick = {
                                save()
                            }
                        }
                        attrs.loading = saving
                        +"保存"
                    }
                }
            }
        }
    }
}
